import React from "react";
import { Box, Typography } from "@mui/material";

const Signature = ({ name, role, company_name, email, mobile_no }) => {
  return (
    <Box>
      <Typography variant="h6" fontWeight="bold">
        {name}
      </Typography>
      <Typography variant="body2" color="GrayText">
        {role} – {company_name}
      </Typography>
      <Typography variant="body2" color="GrayText">
        <a
          href={`mailto:${email}`}
          // style={{ textDecoratio}}
        >
          {email}
        </a>
        , {`+1 ${mobile_no}`}
      </Typography>
    </Box>
  );
};

export default Signature;
